import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { NextRacesHomePageHeader } from './NextRacesHeader';
import { NextRacesSlider } from './racesSlider/NextRacesSlider';
import { useCommon } from 'src/domains/common/Common';
import { NextRacesState } from './NextRaces.state';
import { NextRacesWrapper, RacesSliderSection } from './racesSlider/NextRacesSlider.style';
import { Collapse } from 'src/ui/components/collapse/sports/01/Collapse';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const NextRacesHomePage = observer('NextRacesHomePage', () => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const [nextRacesState] = React.useState(() => new NextRacesState(common));
    const { isNextRacesOpen, toggleNextRacesView } = nextRacesState;

    return (
        <NextRacesWrapper variant={configState.componentVariants.sportsbookVariant}>
            <Collapse
                title={
                    <I18n
                        langKey='special-box.header.next-races'
                        defaultText='Next Races'
                    />
                }
                isOpen={isNextRacesOpen}
                handleToggle={toggleNextRacesView}
            />
            {isNextRacesOpen ? (
                <RacesSliderSection variant={configState.componentVariants.sportsbookVariant}>
                    <NextRacesHomePageHeader nextRacesState={nextRacesState} />
                    <NextRacesSlider nextRacesState={nextRacesState} />
                </RacesSliderSection>
            ) : null}
        </NextRacesWrapper>
    );
});
